export enum PolicyConfigDecisionComponentResultTypes {
    PASS = "true",
    FAIL = "false"
}